import { ResponseService } from './../services/response.service';
import { PhoneService } from './../services/phone.service';
import { CustomDSValidators } from './../shared/validators/custom-validators';
import { Account } from './../interfaces/account.model';
import { ApiService } from './../services/api.service';
import { CustomValidators } from 'ng2-validation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';

@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
})
export class EditAccountComponent implements OnInit {

  private phoneCodes;

  loadingAccount: Boolean;
  loadingPassword: Boolean;

  accountForm: FormGroup;
  passwordForm: FormGroup;
  verificationForm: FormGroup;
  loginlogForm: FormGroup;

  account: Account;

  language: string = '';

  accountLoading: Boolean = true;

  imgSrc: string = '';
  secret: string = '';

  constructor(
    private apiService: ApiService,
    private phoneService: PhoneService,
    private notificationService: NotificationsService,
    private responseService: ResponseService
  ) { }

  ngOnInit() {
    this.phoneCodes = this.phoneService.getCountryCodes();

    let password_old = new FormControl('', [Validators.required]);
    let password_new = new FormControl('', [Validators.required, Validators.minLength(8)]);
    let password_new_confirmation = new FormControl('', [Validators.required, Validators.minLength(8),
    CustomValidators.equalTo(password_new)]);

    this.passwordForm = new FormGroup({
      password_old: password_old,
      password_new: password_new,
      password_new_confirmation: password_new_confirmation
    });

    let cc_phone_notification = new FormControl('');
    let phone_notification = new FormControl('', [CustomDSValidators.internationalPhoneNumber(cc_phone_notification)]);
    let cc_phone_verification = new FormControl('');
    let phone_verification = new FormControl('', [CustomDSValidators.internationalPhoneNumber(cc_phone_verification)]);

    this.accountForm = new FormGroup({
      email: new FormControl({value: '', disabled: true}),
      cc_phone_notification: cc_phone_notification,
      phone_notification: phone_notification,
      cc_phone_verification: cc_phone_verification,
      phone_verification: phone_verification,
      language: new FormControl(''),
      password: new FormControl('', [Validators.required])
    });

    this.verificationForm = new FormGroup({
      verification_method: new FormControl(''),
      password: new FormControl('', [Validators.required])
    });

    this.loginlogForm = new FormGroup({
      can_loginlog: new FormControl(''),
      password: new FormControl('', [Validators.required])
    });

    this.apiService.get('/account').subscribe(
      (response) => {
        this.account = this.responseService.success(false, response, 'user');

        this.accountForm.setValue({
          email: this.account.email,
          cc_phone_notification: this.account.cc_phone_notification === null ? 'PL' : this.account.cc_phone_notification,
          phone_notification: this.account.phone_notification === null ? '' : this.account.phone_notification,
          cc_phone_verification: this.account.cc_phone_verification === null ? 'PL' : this.account.cc_phone_verification,
          phone_verification: this.account.phone_verification === null ? '' : this.account.phone_verification,
          language: this.account.language,
          password: ''
        });

        this.accountLoading = false;
      },
      (error) => {
        this.responseService.error(error);
      }
    )
  }

  validateField(fieldName) {
    this.accountForm.controls[fieldName].updateValueAndValidity();
  }

  changePassword() {
    this.apiService.put('/account/password', this.passwordForm.value).subscribe(
      (response) => {
        this.responseService.success(true, response, false, 'changepassword');
        this.passwordForm.reset();
      },
      (error) => {
        this.responseService.error(error, this.passwordForm, 'changepassword');
      }
    );
  }

  changeAccountData() {
    this.apiService.put('/account', this.accountForm.value).subscribe(
      (response) => {
        this.responseService.success(true, response, false, 'edit');
        this.accountForm.controls['password'].setValue('');
        this.accountForm.controls['password'].markAsUntouched();
      },
      (error) => {
        this.responseService.error(error, false, 'edit');
      }
    );
  }

  changeLoginValidationData() {
    this.apiService.post('/verification/change', this.verificationForm.value).subscribe(
      (response) => {
        this.imgSrc = this.responseService.success(true, response, 'image');
        this.secret = this.responseService.success(false, response, 'secret');
      },
      (error) => {
        this.responseService.error(error, false, 'password');
      }
    );
  }

  changeLoginLogData() {
    this.apiService.post('/logons/change', this.loginlogForm.value).subscribe(
      (response) => {
        this.responseService.success(true, response, 'edit');
      },
      (error) => {
        this.responseService.error(error, false, 'edit');
      }
    );
  }

  toggleMarketing() {
    this.apiService.post('/account/notifications/marketing').subscribe(
      (response) => {
        this.account.notification_settings = this.responseService.success(true, response);
      },
      (error) => {
        this.responseService.error(error, false);
      }
    )
  }

  toggleTechnical() {
    this.apiService.post('/account/notifications/technical').subscribe(
      (response) => {
        this.account.notification_settings = this.responseService.success(true, response);
      },
      (error) => {
        this.responseService.error(error, false);
      }
    )
  }

  togglePayments() {
    this.apiService.post('/account/notifications/payments').subscribe(
      (response) => {
        this.account.notification_settings = this.responseService.success(true, response);
      },
      (error) => {
        this.responseService.error(error, false);
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/account/edit-account.component.ts